import { BASE_IMAGE_URL } from '@app/configs/constants';
import React, { useState } from 'react';
import { Image, ImageStyle, StyleProp } from 'react-native';

interface Props {
  code: string;
  fallback?: string;
  style?: StyleProp<ImageStyle>;
  resizeMode?: 'contain' | 'cover' | 'stretch' | 'center';
}

const RemoteImage: React.FC<Props> = ({
  code,
  fallback = 'default',
  style,
  resizeMode = 'contain',
}) => {
  const [imageUrl, setImageUrl] = useState(
    `${BASE_IMAGE_URL}${code}.png`,
  );

  console.log('imageUrl', imageUrl);

  return (
    <Image
      source={{ uri: imageUrl }}
      style={style}
      resizeMode={resizeMode}
      onError={() => {
        setImageUrl(`${BASE_IMAGE_URL}${fallback}.png`);
      }}
    />
  );
};

export default RemoteImage;
